import { StoreState } from '@/core/models/store.interface';
import { Channel } from 'laravel-echo';
import { Module } from 'vuex';

export interface WebSocketState {
   userChannel?: Channel;
   teamChannel?: Channel;
   globalChannel?: Channel;
}

const WebSocketStore: Module<WebSocketState, StoreState> = {
   namespaced: true,
   state: {},
   getters: {},
   mutations: {
      SET_USER_CHANNEL(state, channel?: Channel) {
         state.userChannel = channel;
      },
      SET_TEAM_CHANNEL(state, channel?: Channel) {
         state.teamChannel = channel;
      },
      SET_GLOBAL_CHANNEL(state, channel?: Channel) {
         state.globalChannel = channel;
      },
   },
   actions: {},
};

export default WebSocketStore;
